/**
 * Created by mukund on 7/17/15.
 */

'use strict';

angular.module('mediacloudApp')
    .controller('PlaybackAnalyticsController', function ($scope, $state, $stateParams, $rootScope, $filter, Principal, CollectionService, PlaybackStats, AssetStats,
                                                         DropOffStats, DeviceOSMetrics, UserStatsByFrequency, $anchorScroll, $location, $sce) {

        Principal.identity().then(function(account) {
            var offset = 0;
            var limit = 10;
            function onSelectItem(items, selection, operation) {
                    if (selection !== undefined) {
                        $scope.changeCollection(selection);
                    }
                }
            document.addEventListener('scrollLimit',() => {
                 offset = offset + limit;
                 CollectionService.GetAllCollections.get({type: 'COURSE', paginated: true, offset: offset, limit: limit}, function(result){
                     $scope.opt.items.push.apply($scope.opt.items, result.collections);
                 });

            });

            var selectedItems = [];

            // Configuration of the vsdropdown
            $scope.opt = {
                items: [],
                selectedItems: selectedItems,
                input: {
                    isObject: true,
                    visiblePropName: 'title'
                },
                filter: {
                    enabled: true,
                    filterPlaceholderTxt: 'Type filter...',
                    noHitsTxt: 'No hits'
                },
                selection: {
                    maximum: 1
                },
                visibleItemCount: 7,
                showTooltip: false,
                fadeInEffects: true,
                itemSelectCb: onSelectItem
            };

            $scope.showBackButton = $rootScope.hideHeaderAndFooter && $state.params.origin.toLowerCase() !== "manager";
            $scope.account = account;
            $scope.isAuthenticated = Principal.isAuthenticated;

            if($scope.isAuthenticated()) {

                // Used by angular date range picker; defaults to last 30 days; use ISO complaint Date format for reliability across browsers/locales
                // read https://github.com/moment/moment/issues/1407 for more information
                $scope.daterange = { startDate: moment().subtract(29, 'days').format("YYYY-MM-DD"), endDate: moment().format("YYYY-MM-DD") }

                $scope.opts = {
                    ranges: {
                        'Today': [moment(), moment()],
                        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                        'Last 30 Days': [moment().subtract(29, 'days'), moment()]
                    },
                    minDate: moment().subtract(364, 'days'),
                    maxDate: moment()
                };

                if($rootScope.hideHeaderAndFooter && $state.params.collectionId && $state.params.collectionId !== "000") {
                    CollectionService.GetCollection.get({cid: $state.params.collectionId, type: 'COURSE' }, function (collection) {
                        // Gets the collection
                        $scope.parent = collection;
                        $scope.courseList = [collection];
                        $scope.courseSelected = collection;
                        $scope.changeCollection($scope.courseSelected);
                    });
                } else {
                    CollectionService.GetAllCollections.get({type: 'COURSE', paginated: true, offset: offset, limit: limit}, function(result){
                        $scope.opt.items=result.collections;
                        selectedItems.push($scope.opt.items[0]);
                        $scope.changeCollection($scope.opt.items[0]);
                    });
                }

                $scope.changeCollection = function(courseSelected){
                    if(courseSelected){
                        $scope.collectionId = courseSelected.cid;
                    }else{
                        $scope.collectionId = courseSelected;
                    }

                    if ($scope.collectionId) {

                        var dateFormatISO = 'YYYY-MM-DD';

                        $scope.userChartOptions = [ { name: "Plays", id: 'play' }, {  name:"Unique Users", id:'unique' }, { name: "Assets", id: 'assets'} ];
                        $scope.userChartOptionSelected = $scope.userChartOptions[0];

                        $scope.mediaOptions = [{  name:"All Media Types", id:'' }, { name: "Video", id: 'video' }, { name: "Audio", id: 'audio' }, { name:"Images", id:'images' } ];
                        $scope.mediaOptionSelected = $scope.mediaOptions[0];

                        //this watches for any changes to daterange and triggers it
                        $scope.$watch('daterange',function callback(newval, oldval){

                            //Default values
                            $scope.statsPerPage = 10;
                            $scope.currentPage = 1;
                            $scope.selectedVal = 1;
                            $scope.frequency = 'day';
                            $scope.runExportStats = true;
                            $scope.dropOffSelected = false;
                            $scope.hideNormalReportTabs = false;
                            $scope.caretClickValue = true;
                            $scope.displayDownCaret = '<span class="caret""></span>';
                            $scope.displayUpCaret = '<span class="dropup"><span class="caret"></span></span>';
                            $scope.ngBindTitleValue = "";
                            $scope.ngBindMinutesPlayedValue = "";
                            $scope.ngBindUniqueUsersValue = "";
                            $scope.ngBindPlayValue = $sce.trustAsHtml($scope.displayDownCaret);
                            $scope.orderType = 'DESC';
                            $scope.orderBy = '4DESC';

                            $scope.start_date = moment($scope.daterange.startDate).format('LL');
                            $scope.end_date = moment($scope.daterange.endDate).format('LL');

                            $scope.runMediaTypeStats(1, $scope.mediaOptionSelected, $scope.statsPerPage);
                            $scope.deviceOsMetrics();
                            $scope.getStats($scope.frequency);

                        }, false);

                        //this watches for any changes to mediaOptionSelected and triggers it
                        $scope.$watch('mediaOptionSelected', function callback(newVal, oldVal){
                            $scope.runExportStats = true;
                        }, false);

                        /* TODO: need to figure out how to use promise for the exporting feature.  This below code can act as a starting point.

                         $scope.getArray = function() {

                         $scope.getHeader = function () {return ["Title", "Plays", "Unique Users", "Collection"]};
                         $scope.filename = "test.csv";
                         var deferred = $q.defer();
                         var promise = deferred.promise;

                        promise.then(function(result){
                            //asynchronous call
                            $scope.playbackstats =   PlaybackStats.query({
                                collectionId: $scope.collectionId,
                                mediaType:$scope.mediaOptionSelected.id,
                                startDate:moment($scope.daterange.startDate).format('MM-DD-YYYY'),
                                endDate:moment($scope.daterange.endDate).format('MM-DD-YYYY'),
                                limit:$scope.totalStats
                            });
                        }, function (reason){
                        });

                        var resultArray = [];
                        for(var i = 0; i < $scope.playbackstats.length; i++){
                            resultArray.push({a: $scope.playbackstats[i].assetTitle, b: $scope.playbackstats[i].playCount, c: $scope.playbackstats[i].uniqueUsers, d: $scope.playbackstats[i].collectionTitle });
                        }
                        deferred.resolve(resultArray);
                        return deferred.promise;
                    }*/

                        $scope.runMediaTypeStats = function(page, mediaTypeOption, itemsPerPage, orderBy, userClick){

                            $scope.statsPerPage = itemsPerPage;

                            //display up and down caret for sorting
                            if(userClick){

                                //sorting initiated when user is NOT at page number 1, should take it back to page number 1
                                if( $scope.currentPage !== 1){
                                    $scope.currentPage = 1;
                                }

                                if(orderBy===2){

                                    $scope.ngBindPlayValue = "";
                                    $scope.ngBindMinutesPlayedValue = "";
                                    $scope.ngBindUniqueUsersValue = "";
                                    if($scope.caretClickValue){
                                        $scope.ngBindTitleValue = $sce.trustAsHtml($scope.displayUpCaret);
                                    }else{
                                        $scope.ngBindTitleValue = $sce.trustAsHtml($scope.displayDownCaret);
                                    }

                                }else if(orderBy===4){

                                    $scope.ngBindTitleValue = "";
                                    $scope.ngBindMinutesPlayedValue = "";
                                    $scope.ngBindUniqueUsersValue = "";
                                    if($scope.caretClickValue){
                                        $scope.ngBindPlayValue = $sce.trustAsHtml($scope.displayUpCaret);
                                    }else{
                                        $scope.ngBindPlayValue = $sce.trustAsHtml($scope.displayDownCaret);
                                    }

                                }else if(orderBy===5){

                                    $scope.ngBindPlayValue = "";
                                    $scope.ngBindUniqueUsersValue = "";
                                    $scope.ngBindTitleValue = "";
                                    if($scope.caretClickValue){
                                        $scope.ngBindMinutesPlayedValue = $sce.trustAsHtml($scope.displayUpCaret);
                                    }else{
                                        $scope.ngBindMinutesPlayedValue = $sce.trustAsHtml($scope.displayDownCaret);
                                    }
                                }else if(orderBy===6){

                                    $scope.ngBindPlayValue = "";
                                    $scope.ngBindTitleValue = "";
                                    $scope.ngBindMinutesPlayedValue = "";
                                    if($scope.caretClickValue){
                                        $scope.ngBindUniqueUsersValue = $sce.trustAsHtml($scope.displayUpCaret);
                                    }else{
                                        $scope.ngBindUniqueUsersValue = $sce.trustAsHtml($scope.displayDownCaret);
                                    }
                                }

                                $scope.caretClickValue = $scope.caretClickValue === false ? true: false;
                                $scope.orderType = $scope.orderType === 'DESC' ? 'ASC' : 'DESC';
                                $scope.orderBy = orderBy + $scope.orderType;
                                console.log("orderBy-->"+$scope.orderBy);
                            }

                            PlaybackStats.query({
                                collectionId: $scope.collectionId,
                                mediaType:mediaTypeOption.id,
                                startDate:moment($scope.daterange.startDate).format(dateFormatISO),
                                endDate:moment($scope.daterange.endDate).format(dateFormatISO),
                                offset: (page-1)*$scope.statsPerPage,
                                limit: $scope.statsPerPage,
                                order: $scope.orderBy
                            }, function(statList){
                                $scope.playbackstats = statList;
                                //using native for loop instead of angular foreach because, there is no break in foreach;
                                // and apparently native for loop is much faster
                                for(var i = 0; i < $scope.playbackstats.length; i++){
                                    $scope.totalStats = $scope.playbackstats[i].totalResultsSize;
                                    $scope.collectionTitleLabel = $scope.playbackstats[i].collectionTitle;
                                    if(i === 0)
                                        break;
                                }
                                //do not run if "runMediaTypeStats" is run because of pagination except on page 1
                                if($scope.runExportStats || page == 1){
                                    $scope.getExportStats($scope.totalStats);
                                }
                            });
                        }

                        $scope.getExportStats = function(totalStats){

                            $scope.getHeader = function () {return ["Title", "Plays", "Minutes Played",  "Unique Users", "Collection"]};
                            $scope.filename = "playbackanalytics.csv";

                            PlaybackStats.query({
                                collectionId: $scope.collectionId,
                                mediaType:$scope.mediaOptionSelected.id,
                                startDate:moment($scope.daterange.startDate).format(dateFormatISO),
                                endDate:moment($scope.daterange.endDate).format(dateFormatISO),
                                limit:totalStats
                            }, function(exportStats){
                                $scope.exportStats = exportStats;
                                $scope.getArray = [];
                                for(var i = 0; i < $scope.exportStats.length; i++){
                                    $scope.getArray.push({a: $scope.exportStats[i].assetTitle, b: $scope.exportStats[i].playCount, c:$scope.exportStats[i].totalMinutesPlayed, d: $scope.exportStats[i].uniqueUsers, e: $scope.exportStats[i].collectionTitle });
                                }
                            });
                        }

                        $scope.pageChanged = function(page){
                            $scope.runExportStats = false;
                            $scope.runMediaTypeStats(page, $scope.mediaOptionSelected, $scope.statsPerPage, $scope.orderBy);
                        };

                        $scope.makeActive = function(asset){
                            return $scope.selected === asset;
                        }

                        $scope.createDropOffChart = function(assetId, assetTitle){

                            $location.hash('areaChart');
                            $anchorScroll();

                            $scope.selected = assetId;
                            $scope.assetLabel = assetTitle;

                            $scope.dropOffSelected = true;
                            $scope.hideNormalReportTabs = true;
                            var dropOffStats = [];

                            var lastElementArray = [];
                            var secondsArray = [];
                            var resultArray = [];
                            var mediaDuration = null;

                            DropOffStats.query({
                                collectionId: $scope.collectionId,
                                assetId: assetId,
                                startDate:moment($scope.daterange.startDate).format(dateFormatISO),
                                endDate:moment($scope.daterange.endDate).format(dateFormatISO)
                            }, function (stats) {
                                dropOffStats = stats;
                                for(var i = 0; i < dropOffStats.length; i++){
                                    //var userId = dropOffStats[i].userId;
                                    var secondsPlayed = dropOffStats[i].secondsPlayed;
                                    mediaDuration = dropOffStats[i].mediaDuration;
                                    secondsArray.push(secondsPlayed);
                                }
                                var firstElementArray = [];
                                for(var j=0; j< secondsArray.length; j++){
                                    if(j==0){
                                        firstElementArray.push(0, secondsArray.length);
                                        resultArray.push(firstElementArray);
                                    }
                                    var userArray = [];
                                    userArray.push(Number(secondsArray[j]), Number(secondsArray.length -j));
                                    resultArray.push(userArray);
                                    if(j == secondsArray.length-1 && (Number(secondsArray[secondsArray.length -1]) < Number(mediaDuration))){
                                        lastElementArray.push(Number(mediaDuration), 0);
                                        resultArray.push(lastElementArray);
                                    }
                                }
                            });

                            $scope.dropOffData = [
                                {
                                    "key": "Users",
                                    "values": resultArray
                                }
                            ];
                        }

                        /*  var formatCount = d3.format(",.0f");*/
                        /* var formatMinutes = function(d) {
                         return d3.time.format("%M:%S")(new Date(2012, 0, 1, 0, d));
                         };*/

                        var formatMinutes = function(d) {
                            if(Number(d) < 3600){
                                return d3.time.format("%Mm:%Ss")(new Date(2012, 0, 1, 0, 0, d));
                            }else{
                                d = Math.round(d / 60);
                                return d3.time.format("%Hh:%Mm")(new Date(2012, 0, 1, 0, d));
                            }
                        };

                        $scope.dropOffOptions = {
                            chart: {
                                /*noData: { color:"yellow"; text-decoration: underline; },*/
                                type: 'stackedAreaChart',
                                height: 400,
                                /* width : 980,*/
                                margin: {
                                    top: 20,
                                    right: 40,
                                    bottom: 60,
                                    left: 40
                                },
                                x: function (d) {
                                    return d[0];
                                },
                                y: function (d) {
                                    return d[1];
                                },
                                clipEdge: true,
                                transitionDuration: 500,
                                useInteractiveGuideline: false,
                                showControls: false,
                                noData: 'No Data Available.',
                                xAxis: {
                                    showMaxMin: true,
                                    tickFormat : formatMinutes,
                                    /* tickFormat: function (d) {
                                     *//* return d3.time.format('%x')(new Date(d))*//*
                                     return d3.format(',.2f')(d)
                                     },*/
                                    xScale: d3.time.scale()
                                },
                                yAxis: {
                                    tickFormat: function (d) {
                                        return d3.format(',.2f')(d);
                                    }
                                }
                            }
                        };

                        $scope.getStats = function(frequency) {

                            $scope.frequency = frequency;
                            $scope.hideNormalReportTabs = false;
                            var startDateTimeInSeconds = moment($scope.daterange.startDate, "YYYY-MM-DD HH:mm:ss").valueOf();
                            var endDateTimeInSeconds = moment($scope.daterange.endDate, "YYYY-MM-DD HH:mm:ss").valueOf();
                            var dateDiff = moment($scope.daterange.endDate, "YYYY-MM-DD").diff(moment($scope.daterange.startDate, "YYYY-MM-DD"), 'days');

                            //get daily stats
                            if ($scope.frequency === 'day') {
                                $scope.selectedVal = 1;
                                $scope.frequency = 'day';
                                $scope.dropOffSelected = false;
                                $scope.assetId = {};
                                var perDayStats = [];
                                var perDayAssetStats = [];
                                var appendedDailyUniqueUserValues = [];
                                var appendedDailyPlayCountValues = [];
                                var appendedDailyAssetCountValues = [];

                                if($scope.userChartOptionSelected.id === 'unique' || $scope.userChartOptionSelected.id === 'play'){

                                    UserStatsByFrequency.query({
                                        collectionId: $scope.collectionId,
                                        startDate:moment($scope.daterange.startDate).format(dateFormatISO),
                                        endDate:moment($scope.daterange.endDate).format(dateFormatISO),
                                        frequency: $scope.frequency
                                    }, function (stats) {
                                        perDayStats = stats;
                                        angular.forEach(perDayStats, function (stats) {
                                            var uniqueUsers = stats.uniqueUsers;
                                            var playCount = stats.playCount;
                                            var dateTimeInSeconds = moment(stats.dateTime, "YYYY-MM-DD HH:mm:ss").valueOf();

                                            var startArray = [];
                                            var endUniqueUserArray = [];
                                            var endPlayCountrArray = [];
                                            var uniqueUserInnerArray = [];
                                            var playCountInnerArray = [];

                                            if(perDayStats.length === 1 && Number(dateDiff) > 1){
                                                startArray.push(Number(startDateTimeInSeconds),0);
                                                appendedDailyUniqueUserValues.push(startArray);
                                                appendedDailyPlayCountValues.push(startArray);
                                            }

                                            uniqueUserInnerArray.push(Number(dateTimeInSeconds), Number(uniqueUsers));
                                            playCountInnerArray.push(Number(dateTimeInSeconds), Number(playCount));
                                            appendedDailyUniqueUserValues.push(uniqueUserInnerArray);
                                            appendedDailyPlayCountValues.push(playCountInnerArray);

                                            //only one result returned
                                            if(perDayStats.length === 1 && Number(dateDiff) === 0){
                                                endUniqueUserArray.push(Number(endDateTimeInSeconds), Number(uniqueUsers));
                                                endPlayCountrArray.push(Number(endDateTimeInSeconds), Number(playCount));
                                                appendedDailyUniqueUserValues.push(endUniqueUserArray);
                                                appendedDailyPlayCountValues.push(endPlayCountrArray);
                                            }
                                        });

                                        if ($scope.userChartOptionSelected.id === 'unique') {
                                            $scope.userData = [
                                                {
                                                    "key": "Users",
                                                    "values": appendedDailyUniqueUserValues
                                                }
                                            ];
                                        } else if ($scope.userChartOptionSelected.id === 'play') {
                                            $scope.userData = [
                                                {
                                                    "key": "Plays",
                                                    "values": appendedDailyPlayCountValues
                                                }
                                            ];
                                        }
                                    });

                                }else if($scope.userChartOptionSelected.id === 'assets'){

                                    AssetStats.query({
                                        collectionId: $scope.collectionId,
                                        frequency: $scope.frequency,
                                        startDate:moment($scope.daterange.startDate).format(dateFormatISO),
                                        endDate:moment($scope.daterange.endDate).format(dateFormatISO)
                                    }, function (assetStats) {
                                        perDayAssetStats = assetStats;

                                        for(var i=0; i< perDayAssetStats.length; i++){
                                            var assetCountDayAggregate = 0;
                                            var dateTimeInSeconds = moment(perDayAssetStats[i].dateTime, "YYYY-MM-DD HH:mm:ss").valueOf();
                                            var assetCount = perDayAssetStats[i].assetCount;
                                            var assetHistoricalCount = perDayAssetStats[i].assetHistoricalCount;
                                            //get asset count until this point in the array
                                            for(var j=0; j< i; j++){
                                                assetCountDayAggregate = Number(perDayAssetStats[j].assetCount) + Number(assetCountDayAggregate);
                                            }

                                            var totalCount = Number(assetCount) + Number(assetCountDayAggregate) + Number(assetHistoricalCount);
                                            var innerArray = [];
                                            innerArray.push(Number(dateTimeInSeconds), Number(totalCount));
                                            appendedDailyAssetCountValues.push(innerArray);
                                        }
                                        $scope.userData = [
                                            {
                                                "key": "Assets",
                                                "values": appendedDailyAssetCountValues
                                            }
                                        ];

                                    });
                                }
                            }

                            //get weekly stats
                            if ($scope.frequency === 'week') {

                                $scope.selectedVal = 2;
                                $scope.frequency = 'week';
                                var perWeekStats = [];
                                var perWeekAssetStats = [];
                                var appendedWeeklyUniqueUserValues = [];
                                var appendedWeeklyPlayCountValues = [];
                                var appendedWeeklyAssetCountValues = [];

                                if($scope.userChartOptionSelected.id === 'unique' || $scope.userChartOptionSelected.id === 'play'){
                                    UserStatsByFrequency.query({
                                        collectionId: $scope.collectionId,
                                        startDate:moment($scope.daterange.startDate).format(dateFormatISO),
                                        endDate:moment($scope.daterange.endDate).format(dateFormatISO),
                                        frequency: $scope.frequency
                                    }, function (stats) {
                                        perWeekStats = stats;
                                        angular.forEach(perWeekStats, function (stats) {
                                            var uniqueUsers = stats.uniqueUsers;
                                            var playCount = stats.playCount;
                                            var dateTimeInSeconds = moment(stats.dateTime, "YYYY-MM-DD HH:mm:ss").valueOf();

                                            var startArray_w = [];
                                            var endUniqueUserArray = [];
                                            var endPlayCountrArray = [];
                                            var uniqueUserInnerArray = [];
                                            var playCountInnerArray = [];

                                            if(perWeekStats.length === 1 && Number(dateDiff) > 1){
                                                startArray_w.push(Number(startDateTimeInSeconds),0);
                                                appendedWeeklyUniqueUserValues.push(startArray_w);
                                                appendedWeeklyPlayCountValues.push(startArray_w);
                                            }

                                            uniqueUserInnerArray.push(Number(dateTimeInSeconds), Number(uniqueUsers));
                                            playCountInnerArray.push(Number(dateTimeInSeconds), Number(playCount));
                                            appendedWeeklyUniqueUserValues.push(uniqueUserInnerArray);
                                            appendedWeeklyPlayCountValues.push(playCountInnerArray);


                                            //only one result returned
                                            if(perWeekStats.length === 1 && Number(dateDiff) === 0){
                                                endUniqueUserArray.push(Number(endDateTimeInSeconds), Number(uniqueUsers));
                                                endPlayCountrArray.push(Number(endDateTimeInSeconds), Number(playCount));
                                                appendedWeeklyUniqueUserValues.push(endUniqueUserArray);
                                                appendedWeeklyPlayCountValues.push(endPlayCountrArray);
                                            }

                                        });

                                        if ($scope.userChartOptionSelected.id === 'unique') {
                                            $scope.userData = [
                                                {
                                                    "key": "Users",
                                                    "values": appendedWeeklyUniqueUserValues
                                                }
                                            ];
                                        } else if ($scope.userChartOptionSelected.id === 'play') {
                                            $scope.userData = [
                                                {
                                                    "key": "Plays",
                                                    "values": appendedWeeklyPlayCountValues
                                                }
                                            ];
                                        }
                                    });

                                }else if($scope.userChartOptionSelected.id === 'assets'){

                                    AssetStats.query({
                                        collectionId: $scope.collectionId,
                                        frequency: $scope.frequency,
                                        startDate:moment($scope.daterange.startDate).format(dateFormatISO),
                                        endDate:moment($scope.daterange.endDate).format(dateFormatISO)
                                    }, function (assetStats) {
                                        perWeekAssetStats = assetStats;

                                        for(var i=0; i< perWeekAssetStats.length; i++){
                                            var assetCountAggregate = 0;
                                            var dateTimeInSeconds = moment(perWeekAssetStats[i].dateTime, "YYYY-MM-DD HH:mm:ss").valueOf();
                                            var assetCount = perWeekAssetStats[i].assetCount;
                                            var assetHistoricalCount = perWeekAssetStats[i].assetHistoricalCount;
                                            //get asset count until this point in the array
                                            for(var j=0; j< i; j++){
                                                assetCountAggregate  += perWeekAssetStats[j].assetCount;
                                            }

                                            var totalCount = Number(assetCount) + Number(assetCountAggregate) + Number(assetHistoricalCount);
                                            var innerArray = [];
                                            innerArray.push(Number(dateTimeInSeconds), Number(totalCount));
                                            appendedWeeklyAssetCountValues.push(innerArray);
                                        }
                                        $scope.userData = [
                                            {
                                                "key": "Assets",
                                                "values": appendedWeeklyAssetCountValues
                                            }
                                        ];

                                    });
                                }
                            }

                            //get monthly stats
                            if ($scope.frequency === 'month') {

                                $scope.selectedVal = 3;
                                $scope.frequency = 'month';
                                var perMonthStats = [];
                                var perMonthAssetStats = [];
                                var appendedMonthlyUniqueUserValues = [];
                                var appendedMonthlyPlayCountValues = [];
                                var appendedMonthlyAssetCountValues = [];

                                if($scope.userChartOptionSelected.id === 'unique' || $scope.userChartOptionSelected.id === 'play'){

                                    UserStatsByFrequency.query({
                                        collectionId: $scope.collectionId,
                                        startDate:moment($scope.daterange.startDate).format(dateFormatISO),
                                        endDate:moment($scope.daterange.endDate).format(dateFormatISO),
                                        frequency: $scope.frequency
                                    }, function (stats) {
                                        perMonthStats = stats;
                                        angular.forEach(perMonthStats, function (stats) {
                                            var uniqueUsers = stats.uniqueUsers;
                                            var playCount = stats.playCount;
                                            var dateTimeInSeconds = moment(stats.dateTime, "YYYY-MM-DD HH:mm:ss").valueOf();

                                            var startArray_m = [];
                                            var endUniqueUserArray = [];
                                            var endPlayCountrArray = [];
                                            var uniqueUserInnerArray = [];
                                            var playCountInnerArray = [];

                                            if(perMonthStats.length === 1 && Number(dateDiff) > 1){
                                                startArray_m.push(Number(startDateTimeInSeconds),0);
                                                appendedMonthlyUniqueUserValues.push(startArray_m);
                                                appendedMonthlyPlayCountValues.push(startArray_m);
                                            }

                                            uniqueUserInnerArray.push(Number(dateTimeInSeconds), Number(uniqueUsers));
                                            playCountInnerArray.push(Number(dateTimeInSeconds), Number(playCount));
                                            appendedMonthlyUniqueUserValues.push(uniqueUserInnerArray);
                                            appendedMonthlyPlayCountValues.push(playCountInnerArray);

                                            //only one result returned
                                            if(perMonthStats.length === 1 && Number(dateDiff) === 0){
                                                endUniqueUserArray.push(Number(endDateTimeInSeconds), Number(uniqueUsers));
                                                endPlayCountrArray.push(Number(endDateTimeInSeconds), Number(playCount));
                                                appendedMonthlyUniqueUserValues.push(endUniqueUserArray);
                                                appendedMonthlyPlayCountValues.push(endPlayCountrArray);
                                            }

                                        });

                                        if ($scope.userChartOptionSelected.id === 'unique') {
                                            $scope.userData = [
                                                {
                                                    "key": "Users",
                                                    "values": appendedMonthlyUniqueUserValues
                                                }
                                            ];
                                        } else if ($scope.userChartOptionSelected.id === 'play') {
                                            $scope.userData = [
                                                {
                                                    "key": "Plays",
                                                    "values": appendedMonthlyPlayCountValues
                                                }
                                            ];
                                        }
                                    });

                                }else if($scope.userChartOptionSelected.id === 'assets'){

                                    AssetStats.query({
                                        collectionId: $scope.collectionId,
                                        frequency: $scope.frequency,
                                        startDate:moment($scope.daterange.startDate).format(dateFormatISO),
                                        endDate:moment($scope.daterange.endDate).format(dateFormatISO)
                                    }, function (assetStats) {
                                        perMonthAssetStats = assetStats;

                                        for(var i=0; i< perMonthAssetStats.length; i++){
                                            var priorAssetCount = 0;
                                            var dateTimeInSeconds = moment(perMonthAssetStats[i].dateTime, "YYYY-MM-DD HH:mm:ss").valueOf();
                                            var assetCount = perMonthAssetStats[i].assetCount;
                                            var assetHistoricalCount = perMonthAssetStats[i].assetHistoricalCount;
                                            //get asset count until this point in the array
                                            for(var j=0; j< i; j++){
                                                priorAssetCount  += perMonthAssetStats[j].assetCount;
                                            }

                                            var totalCount = Number(assetCount) + Number(priorAssetCount) + Number(assetHistoricalCount);
                                            var innerArray = [];
                                            innerArray.push(Number(dateTimeInSeconds), Number(totalCount));
                                            appendedMonthlyAssetCountValues.push(innerArray);
                                        }
                                        $scope.userData = [
                                            {
                                                "key": "Assets",
                                                "values": appendedMonthlyAssetCountValues
                                            }
                                        ];

                                    });
                                }
                            }
                        }//end getStats method

                        $scope.deviceOptions = {
                            chart: {
                                type: 'pieChart',
                                height: 400,
                                width: 400,
                                donut: true,
                                donutRatio: 0.35,
                                x: function(d){return d.key;},
                                y: function(d){return d.value;},
                                showLabels: true,
                                labelType: 'percent',
                                transitionDuration: 350,
                                labelThreshold: .05,
                                legend: {
                                    margin: {
                                        top: 5,
                                        right: 35,
                                        bottom: 5,
                                        left: 0
                                    }
                                }
                            }
                        };

                        $scope.osOptions = {
                            chart: {
                                type: 'multiBarChart',
                                height: 380,
                                width: 170,
                                margin : {
                                    top: 20,
                                    right: 20,
                                    bottom: 60,
                                    left: 45
                                },
                                transitionDuration: 500,
                                stacked: true,
                                showYAxis: false,
                                showControls: false
                            }
                        };

                        $scope.userOptions = {
                            chart: {
                                type: 'stackedAreaChart',
                                height: 400,
                                margin: {
                                    top: 20,
                                    right: 40,
                                    bottom: 60,
                                    left: 40
                                },
                                x: function (d) {
                                    return d[0];
                                },
                                y: function (d) {
                                    return d[1];
                                },
                                clipEdge: false,
                                transitionDuration: 500,
                                useInteractiveGuideline: false,
                                showControls: false,
                                xAxis: {
                                    showMaxMin: true,
                                    tickFormat: function (d) {
                                        return d3.time.format('%x')(new Date(d))
                                    },
                                    xScale: d3.time.scale()
                                },
                                yAxis: {
                                    tickFormat: function (d) {
                                        return d3.format(',.1f')(d);
                                    }
                                }
                            }
                        };

                        //Hide Chart & Show Chart
                        $scope.displayLabel = "Hide Time Graph";
                        $scope.hideValue = false;
                        $scope.hideClickValue = true;

                        $scope.hideGraph =  function(hideClickValue){
                            $scope.hideValue = $scope.hideValue === false ? true: false;
                            $scope.displayLabel = $scope.displayLabel === 'Hide Time Graph' ? 'Show Time Graph': 'Hide Time Graph';
                            $scope.hideClickValue = $scope.hideClickValue === true ? false : true;
                        }

                        $scope.deviceOsMetrics = function(){

                            DeviceOSMetrics.get({
                                collectionId: $scope.collectionId,
                                startDate:moment($scope.daterange.startDate).format(dateFormatISO),
                                endDate:moment($scope.daterange.endDate).format(dateFormatISO)
                            }, function (device) {

                                $scope.device = device;
                                var pcPercent = device.computerPercentage;
                                var mobilePercent = device.mobilePercentage;
                                //tablet data is approximated due to rounding difficulty
                                var tabletPercent = device.tabletPercentage;
                                var macOSPercent = device.macOSPercentage;
                                var windowsOSPercent = device.windowsOSPercentage;
                                var mobileIOSPercent = device.mobileIOSPercentage;
                                var mobileAndroidOSPercent = device.mobileAndroidOSPercentage;
                                var tabletIOSPercent = device.tabletIOSPercentage;
                                var tabletAndroidPercent = device.tabletAndroidPercentage;

                                var mobileOtherPercent = 0;
                                if(mobileIOSPercent !== null || mobileAndroidOSPercent !== null){
                                    mobileOtherPercent = 100 - (Number(mobileIOSPercent) + Number(mobileAndroidOSPercent));
                                }

                                var tabletOtherPercent = 0;
                                if(tabletIOSPercent !== null || tabletAndroidPercent !==null){
                                    tabletOtherPercent = 100 - (Number(tabletIOSPercent) + Number(tabletAndroidPercent));
                                }

                                var pcOtherPercent = 0;
                                if(macOSPercent !== null || windowsOSPercent !== null){
                                    pcOtherPercent =  100 - (Number(macOSPercent) + Number(windowsOSPercent));
                                }

                                if(mobilePercent === null && pcPercent === null && tabletPercent === null){
                                    tabletPercent = 0;
                                }else{
                                    tabletPercent = 100 - (Number(mobilePercent) + Number(pcPercent))
                                }

                                $scope.deviceData = [
                                    {
                                        "key": "Phones",
                                        "value": Number(mobilePercent)
                                    },
                                    {
                                        "key": "PCs",
                                        "value": Number(pcPercent)
                                    },
                                    {
                                        "key": "Tablets",
                                        "value": tabletPercent
                                    }
                                ];

                                // data and options for the multi bar chart
                                $scope.phoneData = [
                                    {
                                        key: "Other",
                                        color: "#386D7C",
                                        values: [
                                            {x: "Phones", y: Number(mobileOtherPercent)}
                                        ]
                                    },
                                    {
                                        key: "Android",
                                        color: "#488B9B",
                                        values: [
                                            {x: "Phones", y: Number(mobileAndroidOSPercent)}
                                        ]
                                    },
                                    {
                                        key: "iOS",
                                        color: "#58ACBA",
                                        values: [
                                            {x: "Phones", y: Number(mobileIOSPercent)}

                                        ]
                                    }
                                ];

                                $scope.tabletData = [
                                    {
                                        key: "Other",
                                        color: "#A0830A",
                                        values: [
                                            {x: "Tablets", y: Number(tabletOtherPercent)}
                                        ]
                                    },
                                    {
                                        key: "Android",
                                        color: "#B7960B",
                                        values: [
                                            {x: "Tablets", y: Number(tabletAndroidPercent)}
                                        ]
                                    }
                                    ,
                                    {
                                        key: "iOS",
                                        color: "#D6AF0B",
                                        values: [
                                            {x: "Tablets", y: Number(tabletIOSPercent)}

                                        ]
                                    }
                                ];

                                $scope.pcData = [
                                    {
                                        key: "Other",
                                        color: "#247043",
                                        values: [
                                            {x: "PCs", y: Number(pcOtherPercent)}
                                        ]
                                    },
                                    {
                                        key: "Windows",
                                        color: "#29844E",
                                        values: [
                                            {x: "PCs", y: Number(windowsOSPercent)}
                                        ]
                                    }
                                    ,
                                    {
                                        key: "Mac",
                                        color: "#30A060",
                                        values: [
                                            {x: "PCs", y: Number(macOSPercent)}

                                        ]
                                    }
                                ];

                            });
                        }
                    }

                }

                $scope.gotoStats = function() {
                    $location.hash('statsSection');
                    $anchorScroll();
                };
            }
        });
    });
